import * as j from '@mojotech/json-type-validation';

import { CampaignListItem } from '~pages/CampaignManagement/domain';

export type CampaignGroup = {
  id: number;
  name: string;
  isActive: boolean;
  archived?: string;
};

export interface CampaignGroupResponse {
  nextPageUrl: string | null;
  list: CampaignGroup[];
}

const CampaignGroupItemResponseDecoder: j.Decoder<CampaignListItem> = j
  .object({
    id: j.number(),
    name: j.string(),
    is_active: j.boolean(),
    archived: j.union(j.string(), j.constant(null)),
  })
  .map((item: any) => ({
    id: item.id,
    name: item.name,
    numLists: item.num_lists,
    isActive: item.is_active,
    archived: item.archived,
  }));

export const CampaignGroupResponseDecoder: j.Decoder<CampaignGroupResponse> = j
  .object({
    next_page_url: j.union(j.string(), j.constant(null)),
    list: j.array(CampaignGroupItemResponseDecoder),
  })
  .map((item: any) => ({
    nextPageUrl: item.next_page_url,
    list: item.list,
  }));
